import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { Box, Paper, Typography } from '@mui/material';
import Strings from '../../../../i18n';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { partNumberAction } from '../../../../utils/validators';
import { useDeleteShippingOrderMutation } from '../../../../services/manufacture/manufactureService';
import { EditShippingOrderSideBarProps } from './editShippingOrderSideBarProps';

interface ShippingDetail {
  id: number;
  manufacturingShippingOrderId: number;
  serialNumber: string;
}

export const EditShippingOrderSideBar = ({
  shippingOrder,
  reloadTable,
  setOpenSideBar,
  setUsersSelected
}: EditShippingOrderSideBarProps) => {
  const [deleteShippingOrder, { isSuccess: isSuccessDelete }] =
    useDeleteShippingOrderMutation();

  const deleteShippingOrderAction = () => {
    if (shippingOrder?.id) {
      deleteShippingOrder(shippingOrder.id);
    }
  };

  useEffect(() => {
    if (isSuccessDelete) {
      toast.success('Data was deleted successfully');
      reloadTable();
      setOpenSideBar(false);
      setUsersSelected([]);
    }
  }, [isSuccessDelete]);

  return (
    shippingOrder && (
      <Formik
        enableReinitialize
        validationSchema={partNumberAction}
        initialValues={{}}
        onSubmit={(values) => {}}
      >
        {() => (
          <>
            <StyledContainerItems>
              <StyledTitleSideBar>
                {Strings.manufacture.shippingOrder.title}
              </StyledTitleSideBar>
              <div className="p-3 border rounded">
                <h4>
                  Shipping Order:
                  {shippingOrder.soNumber}
                </h4>
                <p>
                  Shipping Date:
                  {new Date(shippingOrder.shippingDate).toLocaleString()}
                </p>

                <ul className="list-group mt-3">
                  {shippingOrder.details.map((detail: ShippingDetail) => (
                    <li key={detail.id} className="list-group-item">
                      {detail.serialNumber}
                    </li>
                  ))}
                </ul>
              </div>
              <SideBarDeleteActionWithPopup
                onDelete={() => deleteShippingOrderAction()}
                titleConfirmation={
                  Strings.manufacture.shippingOrder.deleteShippingOrderTitle
                }
                textConfirmation={Strings.common.thisActionIsIrreversible}
                textIcon={
                  Strings.manufacture.shippingOrder.deleteSippingOrderLabel
                }
              />
            </StyledContainerItems>
            <StyledContainerFooterSideBar>
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setOpenSideBar(false);
                  setUsersSelected([]);
                }}
              >
                {Strings.common.cancel}
              </button>
            </StyledContainerFooterSideBar>
          </>
        )}
      </Formik>
    )
  );
};
